import type { ZudokuConfig } from "zudoku";

export const apis: ZudokuConfig["apis"] = [
	{
		type: "file",
		input: "./apis/mobility.yaml",
		path: "/mobility",
		categories: [
			{ label: "Discovery", tags: ["Discovery"] },
			{ label: "Containers", tags: ["Containers"] },
			{ label: "System", tags: ["System"] },
		],
	},
	{
		type: "file",
		input: "./apis/aviation.yaml",
		path: "/aviation",
		categories: [
			{ label: "Discovery", tags: ["Discovery"] },
			{ label: "Containers", tags: ["Containers"] },
			{ label: "System", tags: ["System"] },
		],
	},
	{
		type: "file",
		input: "./apis/marine.yaml",
		path: "/marine",
		categories: [
			{ label: "System", tags: ["System"] },
		],
	},
];
